import { createRouter, createWebHashHistory } from 'vue-router';
import EnvironmentList from './views/EnvironmentList.vue';
import EnvironmentDetail from './views/EnvironmentDetail.vue';
import CreateEnvironment from './views/CreateEnvironment.vue';

// Hash history: deep links work however the api role serves the static assets (no SPA fallback needed),
// and the OIDC redirect URI is one fixed URL (the page itself).
export const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    { path: '/', name: 'list', component: EnvironmentList, meta: { title: 'Environments' } },
    { path: '/new', name: 'create', component: CreateEnvironment, meta: { title: 'New environment' } },
    { path: '/environments/:name', name: 'detail', component: EnvironmentDetail, props: true, meta: { title: 'Environment' } },
    { path: '/:rest(.*)*', redirect: '/' },
  ],
});

router.afterEach((to) => {
  const name = typeof to.params.name === 'string' ? `${to.params.name} · ` : '';
  document.title = `${name}${(to.meta.title as string) ?? 'Peak'} · Peak`;
});
